import React from "react";
import styles from "./Hero.module.css";
import { WHATSAPP_LINK, CALL_LINK } from "../siteData";

const STATS = [
  { value: "10+", label: "Service types" },
  { value: "7 Days", label: "A week availability" },
  { value: "100%", label: "Workmanship focus" },
];

export default function Hero() {
  return (
    <section id="home" className={styles.hero}>
      <div className={styles.backdrop} aria-hidden="true">
        <div className={styles.sweep} />
      </div>

      <div className={`container ${styles.inner}`}>
        <div className={styles.copy}>
          <p className={`jc-eyebrow ${styles.eyebrow}`}>Cleaning &amp; Renovation, One Call Away</p>
          <h1 className={styles.headline}>
            Spaces made <span className={styles.highlight}>spotless</span>,
            rebuilt to <span className={styles.highlight}>last</span>.
          </h1>
          <p className={styles.subline}>
            From a thorough deep clean to a full kitchen or bathroom renovation,
            Jia Cheng Cleaning &amp; Renovation handles homes, offices, shops and
            other properties with dependable service and honest pricing.
          </p>

          <div className={styles.ctaRow}>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className={`jc-btn jc-btn-primary ${styles.ctaBtn}`}
            >
              <WhatsAppIcon />
              Chat on WhatsApp
            </a>
            <a href={CALL_LINK} className={`jc-btn jc-btn-outline ${styles.ctaBtn}`}>
              <PhoneIcon />
              Call Now
            </a>
          </div>

          <dl className={styles.stats}>
            {STATS.map((stat) => (
              <div key={stat.label} className={styles.stat}>
                <dt>{stat.value}</dt>
                <dd>{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className={styles.visual} aria-hidden="true">
          <div className={styles.card}>
            <p className={styles.cardEyebrow}>Today's job sheet</p>
            <ul className={styles.cardList}>
              <li>
                <span className={styles.dot} /> Deep clean — 3-room apartment
              </li>
              <li>
                <span className={styles.dot} /> Bathroom renovation — quote sent
              </li>
              <li>
                <span className={styles.dot} /> Post-renovation clean — office lot
              </li>
              <li>
                <span className={styles.dot} /> Electrical repair — shop lot
              </li>
            </ul>
            <div className={styles.cardFooter}>
              <span>Quality workmanship</span>
              <span>Reasonable prices</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function WhatsAppIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.04 2c-5.5 0-9.96 4.46-9.96 9.96 0 1.76.46 3.48 1.34 4.99L2 22l5.2-1.36a9.9 9.9 0 0 0 4.84 1.24h.01c5.5 0 9.96-4.46 9.96-9.96S17.54 2 12.04 2Zm5.83 14.24c-.25.7-1.24 1.28-2.03 1.44-.55.11-1.26.2-3.66-.79-2.86-1.19-4.79-3.98-4.94-4.16-.14-.19-1.19-1.58-1.19-3.01 0-1.43.75-2.13 1.02-2.42.25-.29.57-.36.76-.36.19 0 .38 0 .55.01.18.01.42-.07.65.5.25.6.85 2.07.92 2.22.07.15.12.32.02.51-.1.19-.15.31-.29.48-.14.17-.3.37-.43.5-.14.14-.29.29-.13.57.16.28.72 1.19 1.55 1.93 1.06.94 1.96 1.24 2.24 1.38.28.14.44.12.6-.07.17-.19.72-.83.91-1.12.19-.28.38-.24.64-.14.26.1 1.66.78 1.94.92.28.14.47.21.53.33.07.12.07.68-.18 1.38Z" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.4 21 3 13.6 3 4.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2Z" />
    </svg>
  );
}
